package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter9.getFacciamoIlPuntoQuizContent
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_ecco_fatto_1
import gero.composeapp.generated.resources.exp_content_ecco_fatto_2
import gero.composeapp.generated.resources.exp_content_ecco_fatto_3
import gero.composeapp.generated.resources.exp_content_ecco_fatto_4
import gero.composeapp.generated.resources.exp_content_ecco_fatto_5
import gero.composeapp.generated.resources.exp_content_ecco_fatto_6
import gero.composeapp.generated.resources.exp_content_ecco_fatto_7
import gero.composeapp.generated.resources.exp_content_ecco_fatto_8
import gero.composeapp.generated.resources.exp_title_ecco_fatto

fun getEccoFattoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_3,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_4,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_5,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_7,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ecco_fatto,
            content = Res.string.exp_content_ecco_fatto_8,
            face = Faces.Serious,
            character = Characters.Masko,
        )
    )
}

fun getEccoFattoQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String,
    adverbialSentencesTsvContent: String? = null
): List<IQuizContent> {
    return getFacciamoIlPuntoQuizContent(hiero, words, languageCode, adverbialSentencesTsvContent)
}
